/* eslint-disable */

import CONST from '@/utils/Constants/General';
import EVENTS from '@/utils/Constants/Events';
import { rebindAll } from '@/search/Controllers/SearchController';
import { emitGtmListingImpression } from '@/utils/Controllers/GTM/Operations/ListingImpression';
import { updateProductsPositionForGTMListing } from '@/utils/Controllers/GTM/Utils';

const updateResults = ({ id, searchType, html }) => {
  let wrapper = document.getElementById(id);
  const isProductSearchType = CONST.SEARCH.TYPE.PRODUCT === searchType;
  if (isProductSearchType) {
    wrapper = document.querySelector('#js-search-products-wrapper');
  }
  if (CONST.SEARCH.TYPE.RECIPE === searchType) {
    wrapper = document.querySelector('#js-dln-recipe-grid');
  }

  Array.from(wrapper.children).forEach(child => wrapper.removeChild(child));
  wrapper.innerHTML = html;

  if (isProductSearchType) {
    emitGtmListingImpression();
  }
  rebindAll(searchType);
};

const appendResults = ({ html, searchType, gtmEvent = null, lastPage }) => {
  const el = document.getElementById(`js-search-tab-${searchType}`);
  const listingLimitEl = el.querySelector('#js-search-service-page-limit');
  listingLimitEl.insertAdjacentHTML('beforebegin', html);
  DLG.EVE.emit(EVENTS.RESULTS.UPDATE);
  listingLimitEl.parentElement.removeChild(listingLimitEl);
  DLG.EVE.emit(EVENTS.SEARCH.RESULTS.PAGEUPDATE, lastPage);
  rebindAll(searchType);
  if (gtmEvent) {
    updateProductsPositionForGTMListing();
    emitGtmListingImpression(gtmEvent);
  }
};

export default () => {
  DLG.EVE.on(EVENTS.SEARCH.RESULTS.UPDATE, updateResults);
  DLG.EVE.on(EVENTS.SEARCH.RESULTS.APPEND, appendResults);
};
